import { ReactElement } from 'react';
import { t } from 'i18next';

import { EmptyStateResearchIcon } from '~/icons';

import { Container, Message } from './styles';

export function EmptyChartsState(): ReactElement {
  return (
    <Container data-testid="maintenance-empty-state">
      <EmptyStateResearchIcon size={280} />
      <Message>{t('nenhumDadoEncontrado')}</Message>
    </Container>
  );
}
